import React from 'react';
import Joi from 'joi-browser';
import Form from "../common/form";
import Button from 'react-bootstrap/Button';

class ManufacturerForm extends Form {
    constructor(props) {
        super(props);
        this.state = {  
            errors:{},
        }
    }

    schema = { 
        manufacturer_name: Joi.string()
            .label("Brand Abbrev.")
            .required()
            .max(60),
        manufacturer_fullname: Joi.string()
            .label("Brand Fullname")
            .required()
            .max(100),
        country_of_origin: Joi.string()
            .label("Country of Origin")
            .required()
            .max(45),
        related_brands_logos: Joi.string()
            .label("Related Brands")
            .optional()
            .empty('')
            .max(100),
        website: Joi.string()
            .label("Website")
            //eslint-disable-next-line
            .regex(/((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/)
            .optional()
            .allow('')
            .max(200),
        kitmolds: Joi.string()
            .label("Kit Molds")
            .optional()
            .empty('')
            .max(200),
        years_active: Joi.string()
            .label("Years Active")
            .optional()
            .empty('')
            .max(50),
        owner_id: Joi.number()
            .optional(),
        manufacturer_id: Joi.number()
            .optional(),
        createdAt: Joi.date()
            .optional(),
        updatedAt: Joi.date()
            .optional()    
     };

    handleAdd = () => {
        this.props.onClearForm();
        document.getElementById('manufacturer_fullname').focus();
     }

    doSubmit() {
        this.props.onFormSubmit();
    }

    render() { 
        return (
            <form onSubmit={this.handleSubmit}>
            <table className="manufacturersFormTable">
                <tbody>
                    <tr>
                        <td>{this.renderInput("manufacturer_fullname", "Brand Full Name", "pencil-alt")}</td>
                    </tr>
                    <tr>
                        <td>{this.renderInput("manufacturer_name", "Brand Abbrev.", "pencil-alt")}</td>
                    </tr>
                    <tr>
                        <td>{this.renderInput("country_of_origin", "Country of Origin", "flag-usa")}</td>
                    </tr>
                    <tr>
                        <td>{this.renderInput("related_brands_logos", "Related Brands", "copyright")}</td>
                    </tr>
                    <tr>
                        <td>{this.renderInput("kitmolds", "Kit Molds", "hard-hat")}</td>
                    </tr>
                    <tr>
                        <td>{this.renderInput("years_active", "Years Active", "calendar-alt")}</td>
                    </tr>
                    <tr>
                        <td>{this.renderInput("website", "Website", "globe-americas")}</td>
                    </tr>
                    <tr>
                        <td><button className="btn btn-primary">Save</button>&nbsp;
                        <Button variant="primary" onClick={this.handleAdd}>Add</Button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </form>
        );
    }
}
 
export default ManufacturerForm;